import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Offer, Trainer } from "../../Data";
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import CodeOffIcon from '@mui/icons-material/CodeOff';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import Footer from "../../Component/Footer/Footer";
import ScrollRevealSection from "../../Component/Animation/scrollRevealSection";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import SupportIcon from "@mui/icons-material/Support";
import "./Home.css";
import { useFetchContentQuery } from "../../Redux/Api/ContentApi";
import Splash from "../../Component/Splash/Splash";
//import about from "../../"


const Home = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [contentData, setContentData] = useState(null);
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  const { data, isLoading, isSuccess, error,refetch} = useFetchContentQuery();
  const words = ["CREATIVE", "INNOVATIVE", "MINIMAL", "FUTURE"];

  useEffect(() => {
    if (isSuccess) {
      setContentData(data);
    }
  }, [data, setContentData, isSuccess]);
   
    useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % words.length);
        setAnimate(true);
      }, 600);
    }, 30000);

    return () => clearInterval(interval);
  }, []);



    if(isLoading){
      return <Splash/>
    }
    /*
    if(error){
    return (
      <>
       <div id="splash">
        <img src="/images/logo2.png" alt="Logo" id="splash-logo" />
      </div>
      <div className="retry">
        <button id="retry-btn" onClick={refetch}>Retry</button>
        <p >Failed to load data</p>
      </div>
      </>
     
     )
    }
  */


  return (
    <div className="kiga-home-main">
      <header className="kiga-home-main-header" style={{
       background:`linear-gradient(to left, rgba(000, 000, 000, 0.62),
       rgba(171, 218, 220, 0.29)),url('images/Gallery/bac1.jpg')`,
          backgroundRepeat:'no-repeat',
          backgroundSize:'cover',
          objectFit:'cover',
          backgroundPosition: "center"}}>
       <nav className="kiga-home-main-navbar">
       <div className="kiga-home-main-header-logo">
          <Link to="/">
            <img src="/images/logo2.png" alt="logo" />
          </Link>
        </div>
        <div className="kiga-home-main-header-links">
         <p><Link to="/">Home</Link></p>
         <p><Link to="/about">About</Link></p>
         <p><Link to="/classes">Classes</Link></p>
         <p><Link to="/portal/booking">Booking</Link></p>
         <p><Link to="/Gallery">Gallery</Link></p>
         <p><Link to="/contact">Contact</Link></p>
        </div>
        <div className="kiga-home-main-header-portal">
         <p><Link to="/login">Members Portal</Link></p>
        </div>
        {/* Hamburger Icon */}
        <div
          className="nav-hamburger"
          onClick={() => setIsNavExpanded(!isNavExpanded)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        {/* Mobile fullscreen nav */}
        <div
          className={isNavExpanded ? "sub-nav-links-expanded" : "sub-nav-links"}
        >
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/classes">Classes</Link>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/register">Booking</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/login">Members</Link>
            </li>
          </ul>
          <div
            className="sub-nav-close-btns"
            onClick={() => setIsNavExpanded(false)}
          >
            <p>X</p>
          </div>
        </div>
       </nav>
      </header>
      <div className="kiga-home-main-big-title">
        <h4>Welcome</h4>
        <h1>Kigali International <span>Gymnastic Academy</span></h1>
      </div>
      <div className="kiga-home-main-small-para">
        <p>Kigali International Gymnastics Academy, we believe in the power of
        discipline, creativity, and perseverance. Founded with a passion for
        acrobatics and gymnastics arts, our academy is dedicated to training
        and inspiring the next generation of gymnasts and young athletes.
        </p>
      </div>
      <div className="kiga-home-main-button">
       <Link to={null}>Find Classes</Link>
      </div>
      <div className="kiga-home-main-social">
        <Link to={null}><InstagramIcon className='instagram'/></Link>
        <Link to={null}><CodeOffIcon className='facebook'/></Link>
        <Link to={null}><XIcon className='twitter'/></Link>
        <Link to={null}><WhatsAppIcon className='whatsapp'/></Link>
      </div>
      <section className="kiga-page-all-discipline">
        <div className="kiga-page-all-image">
          <img src="/images/Gallery/child1.jpg" alt="disci" />
          <div className="kiga-homepage-overlay">
            <h2>Meet Our Stars</h2>
            <p>
              These young athletes are building strength, confidence, and fun
              skills together!
            </p>
            <Link to="/register" className="kiga-homepage-join-btn">
              <span>Join Now</span>
              <i className="fa fa-arrow-right"></i>
            </Link>
          </div>
        </div>
        <div className="kiga-page-all-image">
          <img src="/images/Gallery/child3.jpg" alt="disci" />
          <div className="kiga-homepage-overlay">
            <h2>Meet Our Stars</h2>
            <p>
              These young athletes are building strength, confidence, and fun
              skills together!
            </p>
            <Link to="/register" className="kiga-homepage-join-btn">
              <span>Join Now</span>
              <i className="fa fa-arrow-right"></i>
            </Link>
          </div>
        </div>
        <div className="kiga-page-all-image">
          <img src="/images/Gallery/child4.jpg" alt="disci" />
          <div className="kiga-homepage-overlay">
            <h2>Meet Our Stars</h2>
            <p>
              These young athletes are building strength, confidence, and fun
              skills together!
            </p>
            <Link to="/register" className="kiga-homepage-join-btn">
              <span>Join Now</span>
              <i className="fa fa-arrow-right"></i>
            </Link>
          </div>
        </div>
        <div className="kiga-page-all-image">
          <img src="/images/Gallery/child5.jpg" alt="disci" />
          <div className="kiga-homepage-overlay">
            <h2>Meet Our Stars</h2>
            <p>
              These young athletes are building strength, confidence, and fun
              skills together!
            </p>
            <Link to="/register" className="kiga-homepage-join-btn">
              <span>Join Now</span>
              <i className="fa fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </section>
      <section className="kiga-homepage-about-section">
        <ScrollRevealSection>
          <div className="kiga-homepage-about-info">
            <div className="kiga-about-small-title">
              <p>About us</p>
            </div>
            <div className="kiga-about-big-title">
              <h2>KIGALI INTERNATIONAL <span>GYMNASTICS ACADEMY</span></h2>
              <p>
                At Kigali International Gymnastics Academy, we believe in the
                power of discipline, creativity, and perseverance. Founded with
                a passion for acrobatics and gymnastics arts, our academy is
                dedicated to training and inspiring the next generation of
                gymnasts and young athletes. Our specialized Coach is a well
                known figure in the field of Gymastics with more than 11 years
                of experience in coaching and training young talents. We provide
                a structured and supportive environment where students can
                develop their skills, confidence, and physical strength through
                Gymnastics and Acrobtics weekly classes. We are currently
                located at Nyarutarama Sports Center ( 22KG, 13 Avenue.
                Nyarutarama) well known as Tennis Club.
              </p>
            </div>
            <div className="about-kiga-overview-who-content-button">
              <p>
                <Link to="/contact">contact Us</Link>
              </p>
            </div>
          </div>
        </ScrollRevealSection>
        <ScrollRevealSection>
        <div className="circle-container">
         <div className="main-circle">
        <span className={`main-text ${animate ? "fade-in" : "fade-out"}`}>
       <div style={{ position: "relative", width: "100%", height: "0px", paddingBottom: "56.250%" }}>
        <iframe 
          src="https://streamable.com/e/rt0v3k?autoplay=1&muted=1" 
          allow="fullscreen;autoplay" 
          allowFullScreen 
          style={{
            border: "none", 
            width: "100%", 
            height: "100%", 
            position: "absolute", 
            left: "0px", 
            top: "0px", 
            overflow: "hidden"
          }}
        ></iframe>
       </div>
        </span>
      </div>

      <div className="orbit">
        <div className="small-circle" data-text="Design" />
        <div className="small-circle" data-text="Code" />
        <div className="small-circle" data-text="Motion" />
      </div>
    </div>
        </ScrollRevealSection>
      </section>
      <section className="kiga-homepage-parent-page">
        <ScrollRevealSection>
          <aside className="kiga-homepage-parent-login-info">
            <div className="kiga-homepage-parent-login-info-title">
              <h2>Parent Portal </h2>
            </div>
            <div className="kiga-homepage-parent-login-info-flex">
              <div>
                <p>
                  <Link to="/portal/booking">Class Schedules</Link>
                </p>
              </div>
              <div>
                <p>
                  <Link to="/portal/booking">Event Schedules</Link>
                </p>
              </div>
              <div>
                <p>
                  <Link to="/login">Parent Login / Register Account</Link>
                </p>
              </div>
            </div>
          </aside>
        </ScrollRevealSection>
        <ScrollRevealSection>
          <aside className="kiga-homepage-parent-info">
            <div className="kiga-homepage-parent-info-content">
              <h2>New to Gymnastics? Try a FREE class!</h2>
              <p>
                K.I.G.A offers one free trial class to new members! To check one
                out: 1) Create an account; 2) Add students to your account; 3)
                Find a suitable class and click ‘Enroll’; 4) Change enrollment
                type to ‘Trial’
              </p>
            </div>
            <div className="kiga-homepage-parent-info-content">
              <h2>Already have an athlete enrolled?</h2>
              <p>
                You already have an online account! Visit the “Parent Login”
                site, and click “Forgot Password” if you are unsure of your
                password. Once logged in, you may: 1) View Payment History; 2)
                Update Payment Methods; 3) Make payments; 4) Update contact
                information; 5) Schedule make-ups; 6) Request a transfer, or
                drop from class
              </p>
            </div>
          </aside>
        </ScrollRevealSection>
      </section>
      <section className="kiga-homepage-why-discripline" id="discipline">
        <div className="kiga-homepage-why-discripline-flex-title">
          <div className="kiga-homepage-why-discripline-left"></div>
          <div className="kiga-homepage-why-discripline-right">
            <p>Why Gymnastics, Tumbling or Acrobatics?</p>
          </div>
        </div>
        <ScrollRevealSection>
          <div className="kiga-homepage-why-discripline-flex">
            <div className="kiga-homepage-why-discripline-box">
              <div className="kiga-homepage-why-discripline-box-icons">
                <SelfImprovementIcon className="self-improve" />
              </div>
              <div className="kiga-homepage-why-discripline-box-title">
                <p>encourege self Discovery</p>
              </div>
              <div className="kiga-homepage-why-discripline-box-content">
                <p>
                  With the increased demand for academic achievement, and the
                  distractive ability of modern technology, children have less
                  time than ever to discover the amazing feats their body is
                  capable of achieving. The greatest discovery your child can
                  make, is who they truly are.{" "}
                </p>
              </div>
            </div>
            <div className="kiga-homepage-why-discripline-box">
              <div className="kiga-homepage-why-discripline-box-icons">
                <TrendingUpIcon className="self-improve" />
              </div>
              <div className="kiga-homepage-why-discripline-box-title">
                <p>Change Their Life</p>
              </div>
              <div className="kiga-homepage-why-discripline-box-content">
                <p>
                  Regular socialization is paramount to a child’s understanding
                  of the needs and feelings of others, as well as for developing
                  their ability to improvise, and adjust to various social
                  situations. This makes gymnastics class the perfect social
                  experiment.{" "}
                </p>
              </div>
            </div>
            <div className="kiga-homepage-why-discripline-box">
              <div className="kiga-homepage-why-discripline-box-icons">
                <StackedLineChartIcon className="self-improve" />
              </div>
              <div className="kiga-homepage-why-discripline-box-title">
                <p>Bring Out Their Best</p>
              </div>
              <div className="kiga-homepage-why-discripline-box-content">
                <p>
                  Gymnastics is a total body sport utilizing functional muscle
                  groups that, when properly exercised, will allow your child to
                  achieve amazing feats. All while increasing cardiovascular
                  health, longevity, strength, endurance, flexibility, and
                  mental fortitude
                </p>
              </div>
            </div>
            <div className="kiga-homepage-why-discripline-box">
              <div className="kiga-homepage-why-discripline-box-icons">
                <SupportIcon className="self-improve" />
              </div>
              <div className="kiga-homepage-why-discripline-box-title">
                <p>Help Them Meet Their Goals</p>
              </div>
              <div className="kiga-homepage-why-discripline-box-content">
                <p>
                  The most successful individuals are those with the drive and
                  determination to see things through, even when they get hard.
                  The constant training required from gymnastics will give your
                  child the stick-to-it-ness to get through anything life can
                  throw at them.
                </p>
              </div>
            </div>
          </div>
        </ScrollRevealSection>
      </section>
      <section className="kiga-homepage-tuition-registration">
        <div className="kiga-homepage-tuition-registration-title">
          <h2>Tuition & Registration</h2>
        </div>
        <ScrollRevealSection>
          <div className="kiga-homepage-tuition-registration-box-flex">

           <div className="kiga-homepage-tuition-registration-box-red">
            <div className="kiga-homepage-tuition-registration-box-content">
              <div className="kiga-homepage-tuition-registration-box-content-image">
                <img src="/images/classes-icon.png" alt="classes icons"/>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-title">
                <p>Classes</p>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-para">
                <p>Find a class that’s perfect for your schedule and your child’s age range. Each class is designed to support your child’s physical, social, and emotional growth.</p>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-red-button">
                <Link to="/portal/booking">Find Your Gym'S Schedules</Link>
              </div>
            </div>
           </div> 
           <div className="kiga-homepage-tuition-registration-box-blue">
            <div className="kiga-homepage-tuition-registration-box-content">
              <div className="kiga-homepage-tuition-registration-box-content-image">
                <img src="/images/membership.webp" alt="classes icons"/>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-title">
                <p>Membership</p>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-para">
                <p>Choose the membership package that fits your family best. Create healthy habits for you and your children while saving money and enjoying rewards.</p>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-blue-button">
                <Link to={null}>Learn More</Link>
              </div>
            </div>
           </div>
          <div className="kiga-homepage-tuition-registration-box-green">
            <div className="kiga-homepage-tuition-registration-box-content">
              <div className="kiga-homepage-tuition-registration-box-content-image">
                <img src="/images/parties.webp" alt="classes icons"/>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-title">
                <p>Parties & more</p>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-para">
                <p>Our birthday parties are simply AWESOME. Our camps are educational and fun. Plus, our Parent Survival Night gives you the break you deserve</p>
              </div>
              <div className="kiga-homepage-tuition-registration-box-content-green-button">
                <Link to={null}>Discover More</Link>
              </div>
            </div>
           </div>      
          </div>

        </ScrollRevealSection>
      </section>
      <section className="kiga-homepage-classes-offered">
        <div className="kiga-homepage-classes-offered-flex">
          <div className="kiga-homepage-classes-offered-flex-left"></div>
          <div className="kiga-homepage-classes-offered-flex-right">
            <h2>Classes Offered</h2>
          </div>
        </div>

        <div className="kiga-homepage-classes-offered-grid">
          <ScrollRevealSection>
            <div className="kiga-homepage-classes-offered-grid-box-flex">
              <div className="kiga-homepage-classes-offered-grid-box-image">
                <img src="/images/acrobat4.jpg" alt="grid" />
              </div>
              <div className="kiga-homepage-classes-offered-grid-box-content">
                <div className="kiga-homepage-classes-offered-grid-box-content-title">
                  <p>Beginner Class</p>
                </div>
                <div className="kiga-homepage-classes-offered-grid-box-content-info">
                  <p>
                    Our Beginners' Gymnastics classes utilize various apparatus
                    to help pre-schoolers develop coordination, listening
                    skills, patience, strength, balance, and flexibility. Entry
                    level skills such as rolls and handstands are practiced in
                    this program.<strong>Ages 1.5-3 & 3-5.</strong>
                  </p>
                </div>
              </div>
            </div>
          </ScrollRevealSection>
          <ScrollRevealSection>
            <div className="kiga-homepage-classes-offered-grid-box-flex">
              <div className="kiga-homepage-classes-offered-grid-box-image">
                <img src="/images/acrobat1.jpg" alt="grid" />
              </div>
              <div className="kiga-homepage-classes-offered-grid-box-content">
                <div className="kiga-homepage-classes-offered-grid-box-content-title">
                  <p> Intermediate and Advanced Gymnastics levels</p>
                </div>
                <div className="kiga-homepage-classes-offered-grid-box-content-info">
                  <p>
                    Artistic Gymnastics is offered to both male and female
                    students, for females, they will utilize Balance Beams,
                    Bars, Vault Boards, and Air Tracks to improve balance,
                    strength, and tumbling skills.For males gymnasts,they will
                    be working on floor gymnastics, parallel bars and vaults.
                    <strong>Ages 5-16.</strong>
                  </p>
                </div>
              </div>
            </div>
          </ScrollRevealSection>
          <ScrollRevealSection>
            <div className="kiga-homepage-classes-offered-grid-box-flex">
              <div className="kiga-homepage-classes-offered-grid-box-content">
                <div className="kiga-homepage-classes-offered-grid-box-content-title">
                  <p>Acrobatics</p>
                </div>
                <div className="kiga-homepage-classes-offered-grid-box-content-info">
                  <p>
                    Acrobatics combines the beauty of dance with the strength
                    and agility of partner acrobatics. Static partner holds
                    characterize the acrobatic balance routine, while
                    synchronized tumbling and flight elements define the dynamic
                    exercises.<strong>Ages 5+.</strong>
                  </p>
                </div>
              </div>
              <div className="kiga-homepage-classes-offered-grid-box-image">
                <img src="/images/acrobat2.jpg" alt="grid" />
              </div>
            </div>
          </ScrollRevealSection>
          <ScrollRevealSection>
            <div className="kiga-homepage-classes-offered-grid-box-flex">
              <div className="kiga-homepage-classes-offered-grid-box-content">
                <div className="kiga-homepage-classes-offered-grid-box-content-title">
                  <p>Tumbling</p>
                </div>
                <div className="kiga-homepage-classes-offered-grid-box-content-info">
                  <p>
                    Unlike gymnastics, where students utilize various apparatus,
                    tumbling consists of floor and trampoline/air track skills
                    only. These skills include cartwheels, handstands, rolls,
                    handsprings, and more advanced tumbling skills at higher
                    levels.<strong>Ages 5-17.</strong>
                  </p>
                </div>
              </div>
              <div className="kiga-homepage-classes-offered-grid-box-image">
                <img src="/images/acrobat3.jpg" alt="grid" />
              </div>
            </div>
            <div className="kiga-homepage-classes-offered-grid-box-flex">
              <div className="kiga-homepage-classes-offered-grid-box-content">
                <div className="kiga-homepage-classes-offered-grid-box-content-title">
                  <p>Rhythmic</p>
                </div>
                <div className="kiga-homepage-classes-offered-grid-box-content-info">
                  <p>
                    Unlike other gymnastics disciplines, Rhythmic gymnastics is
                    only done by females where students utilize various
                    apparatus such as ball, ribbons, clubs and hoops. Rhythimic
                    consists of gymnastics,dance, ballet and calisthenics.
                    Gymnasts in Rhythmic perfom on floor mat emphasizin grace,
                    flexibility, coordination and artistic expression
                    whileinteracting seamlessly with their chosen
                    apparatus.trampoline/air track skills only.
                    <strong>Ages 5-17.</strong>
                  </p>
                </div>
              </div>
              <div className="kiga-homepage-classes-offered-grid-box-image">
                <img src="/images/acrobat1.jpg" alt="grid" />
              </div>
            </div>
          </ScrollRevealSection>
        </div>
      </section>
      <section className="kiga-homepage-philosoph" >
        <div className="kiga-homepage-philosoph-big-title">
          <h2>At Kigali International Gymnastics Academy</h2>
        </div>
        <div className="kiga-homepage-philosoph-small-title">
          <p>
            we believe that gymnastics is both a sport and an art—an inspiring
            path to discipline, self-expression, and personal growth.Our
            philosophy combines structured coaching with creative exploration,
            allowing each child to develop confidence, strength, and focus in a
            supportive and inclusive environment.We partner closely with
            families, schools, and the community to nurture the full potential
            of every young athlete—not just in physical skill, but also in
            character, resilience, and leadership. Through consistent training
            and positive mentorship, we aim to shape strong individuals who
            carry the values of perseverance, teamwork, and excellence into
            every part of their lives.
          </p>
        </div>
        <div className="custom-shape-divider-bottom-1773825375">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" class="shape-fill"></path>
          </svg>
       </div>
      </section>
      {/*  Component of Trainer   */}
      <section className="expert-trainer">
        <div className="expert-trainer-title">
          <p>Meet Our Coachers</p>
          <p>Our Coachers</p>
        </div>
        <div className="expret-trainer-section">
          {Trainer?.map((el, index) => (
            <div
              className="expert-trainer-box"
              key={index}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="expert-trainer-box-image">
                <img src={el.image} alt="expert" />
              </div>
              <div className="expert-trainer-box-content">
                <div className="expert-trainer-box-name">
                  <p>{el.name}</p>
                  <p>+{el.exp} Of Experience Years</p>
                  <p>
                    <span>
                      <i className="fa fa-phone" aria-hidden="true"></i>
                    </span>
                    {el.tel}
                  </p>
                </div>
              </div>
              <div className="expert-trainer-box-social-flex">
                {el.social.map((data, index) => (
                  <div
                    className={`expert-trainer-box-social-${data.name}`}
                    key={index}
                  >
                    <i className={data.icons}></i>
                  </div>
                ))}
              </div>

              <div className="expert-trainer-box-desc">
                <p>{el.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="kiga-homepage-comments">
        <div className="kiga-homepage-comments-big-title">
          <p>What are the best in the Industry saying?</p>
          <p>Parent,Schools Principles,More</p>
        </div>
        <div className="kiga-homepage-comments-content">
          <div className="kiga-homepage-comments-content-box">
            <p>
              🗣️ “KIGA has truly transformed my child’s confidence and focus.
              The discipline and joy they bring into each class is amazing.” —
              John Kelly
            </p>
            <p>Parent of a 9-year-old student</p>
          </div>
          <div className="kiga-homepage-comments-content-box">
            <p>
              🗣️ “I’ve seen my daughter grow stronger—not just physically, but
              mentally. KIGA is more than a gym, it’s a second home.” — jeannet
              Shannod
            </p>
            <p>Parent of a young gymnast</p>
          </div>
          <div className="kiga-homepage-comments-content-box">
            <p>
              🏫 “KIGA has been an excellent partner in promoting physical
              education and discipline among our students. Their professionalism
              and care stand out.” — School Principal, Green Hills Academy
            </p>
            <p>Joyce</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
